// import SettingChat from '@src/components/SettingChat';
import ChangePassword from '@src/components/ChangePassword';
import { ROLE_VALUE } from '@src/constants';
import GeneralSettings from './GeneralSettings';

export default [
  {
    value: 'generalSetting',
    label: 'Cài đặt chung',
    component: GeneralSettings,
    role: [ROLE_VALUE.SUPER_ADMIN],
  },
  // {
  //   value: 'settingChat',
  //   label: 'Cài đặt thông báo',
  //   component: SettingChat,
  //   role: [ROLE_VALUE.SUPER_ADMIN, ROLE_VALUE.EMPLOYEE],
  // },
  {
    value: 'changePassword',
    label: 'Đổi mật khẩu',
    component: ChangePassword,
    role: [ROLE_VALUE.SUPER_ADMIN, ROLE_VALUE.EMPLOYEE],
  },
];
